let isCopyProtectionLoaded = false

export function useCopyProtection() {

}